// extracted by mini-css-extract-plugin
export var button = "_db-4";
export var hasDarkBackground = "_db-7";
export var hasLightBackground = "_db-6";
export var iconWrapper = "_db-0";
export var large = "_db-2";
export var medium = "_db-1";
export var small = "_db-5";
export var xsmall = "_db-3";